import { toast } from "react-toastify";
import { endpoints, oids } from "@/configs/Settings";
import { HTTPResponseStatus } from "@/utils/enum";

import { useAuth } from "@/utils/useAuth";
import { useAxios } from "@/utils/useAxios";
import { auxiliarData } from "@/services/fhir/AuxiliarData";
import { ITaskData } from "@/utils/interfaces";
import { PostTask } from "@/services/fhir/task/PostTask";
import { GetEncounter } from "@/services/fhir/encounter/GetEncounter";

export async function PostAnnotation(
  noteText: string,
  encounterReference: any,
  basedOn?: Array<{ reference: string }>,
  organizationId?: string,
  patientName?: string,
  uuidValue?: string
) {
  console.log("PostAnnotation START", { hasComment: !!noteText, encounterId: encounterReference?.id });
  
  try {
    // Busca o Encounter usando appointmentId (padrão do sistema)
    const encounterResponse = await GetEncounter({
      patientId: encounterReference.subject,
      appointmentId: encounterReference.appointmentId,
      lastUpdaded: true,
      // count 20: com teleconsultoria há 2 Encounters no mesmo Appointment.
      count: 20,
    });
    
    console.log("Encounter response:", encounterResponse);
    
    // Prefere o Encounter do atendimento aberto; fallback no mais recente.
    const fullEncounter =
      encounterResponse?.entry?.find(
        (el: any) => el?.resource?.id === encounterReference?.id
      )?.resource || encounterResponse?.entry?.[0]?.resource;
    console.log("Encounter completo obtido:", fullEncounter);
    
    if (!fullEncounter) {
      throw new Error("Encounter não encontrado");
    }
    
    // Monta o encounter com os dados completos
    const practitionerParticipant = fullEncounter.participant?.find((p: any) => 
      p.actor?.reference?.includes("Practitioner")
    );
    
    // Usa organizationId passado como parâmetro ou extrai do serviceProvider como fallback
    const finalOrganizationId = organizationId;
    
    // Extrai practitionerId do participant
    const practitionerId = practitionerParticipant?.actor?.reference?.split("/")[1];
    
    // Monta a referência do PractitionerRole
    const practitionerRoleReference = `PractitionerRole/${finalOrganizationId}-${practitionerId}`;
    
    const encounter = {
      id: fullEncounter.id,
      subject: encounterReference.subject,
      requester: {
        reference: practitionerRoleReference,
        display: practitionerParticipant?.actor?.display,
      }
    };
    
    console.log("Encounter montado:", encounter);
    
    const url = `${endpoints.EHRPOSTER}/`;
    const data = auxiliarData.ServiceRequestNoteOnly(noteText, encounter, basedOn, uuidValue);
    console.log("Bundle criado:", data);

    const headers = {
      Accept: "application/fhir+json",
      Authorization: await useAuth.getUserToken(),
      "Content-Type": "application/fhir+json",
    };

    const response = await useAxios
      .post(url, data, { headers, timeout: 20000 })
      .then((response) => {
        if (
          response.status !== HTTPResponseStatus.Created &&
          response.status !== HTTPResponseStatus.Success
        ) {
          throw new Error(`PostAnnotation: ${response.status}`);
        }

        if (encounter?.requester) {
          console.log("entrou com requester", encounter?.requester);
          const taskData: ITaskData = {
            status: "requested",
            intent: "order",
            priority: "routine",
            code: {
                text: `O paciente ${patientName} submeteu uma anotação`,
                coding: [
                  {
                    system: "https://fluxmed.com.br/fhir/CodeSystem/task-types",
                    code: "NOTIFICATION_DOCUMENT",
                  },
                ],
              },
            description: `Nova anotação no prontuário`,

            owner: `Patient/${oids.cpf}-${encounter?.subject}`,
            for: encounter?.requester?.reference,
          };

          PostTask(taskData);
        }
        return response.data;
      })
      .catch((error) => {
        console.error("PostAnnotation ", error);
        throw new Error();
      });
    
    if (response) return response;
  } catch (error) {
    console.error("PostAnnotation error:", error);
    throw error;
  }
}
